export default __webpack_public_path__ + "static/media/GLMath.79e49d55.jpg";